export default "__VITE_ASSET__CNyI$PCV__"